import React from 'react';
import { ConfigLayer, MapModes } from '@innovyze/inno-map';
import { MapCardStyle } from './EditSensor.styles';
import { InfoCard } from '@innovyze/stylovyze';
import SensorConfigurationMap from '@Components/SensorConfigurationMap/SensorConfigurationMap';
import { MapLocationPosition } from '@Hooks';
import {
	DataServiceType,
	GeoJsonInputType,
} from '@innovyze/inno-map/map/services/types';
import { useGlobalization } from '@Translations';

interface LocationCardProps {
	position: MapLocationPosition;
	dataSources: DataServiceType<unknown>[] | undefined;
	layerConfig?: ConfigLayer[];
}

const LocationCard: React.FC<LocationCardProps> = (
	props: LocationCardProps,
) => {
	const { position, dataSources }: LocationCardProps = props;

	const { t } = useGlobalization();

	return (
		<InfoCard title={t('Location')}>
			<MapCardStyle>
				<SensorConfigurationMap
					dataServices={
						(dataSources as GeoJsonInputType[] | undefined) || []
					}
					position={position || {}}
					mapMode={MapModes.Static}
					layerConfig={props.layerConfig}
				/>
			</MapCardStyle>
		</InfoCard>
	);
};

export default LocationCard;
